import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import BseDataRepository from '../../../../data/repositories/BseDataRepository';
import BseRepository from '../../../repositories/BseRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    XCheckpointManager.registerStart('BSE - Activar pago');
    yield put({ type: Types.ACTIVATE_PAY_ORDER_REQUEST });
    const scholarshipsBseRepository: BseRepository = new BseDataRepository();
    const activatePayOrderResponse = yield call(
      scholarshipsBseRepository.activatePayOrder,
      action.operationNumber,
      action.origin
    );
    XCheckpointManager.registerEnd('BSE - Activar pago');
    if (!activatePayOrderResponse) {
      yield put({
        type: Types.ACTIVATE_PAY_ORDER_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    yield put({
      type: Types.ACTIVATE_PAY_ORDER_SUCCESS,
      // operationNumber: activatePayOrderResponse?.data
      data: activatePayOrderResponse?.data
    });
  } catch (error) {
    yield put({
      type: Types.ACTIVATE_PAY_ORDER_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
